import {
  CREATE_SELF_INTRO_MEDIA,
  CREATE_SELF_INTRO_MEDIA_SUCCESS,
  CREATE_SELF_INTRO_MEDIA_FAILURE,
  FETCH_SELF_INTRO_MEDIA,
  FETCH_SELF_INTRO_MEDIA_SUCCESS,
  FETCH_SELF_INTRO_MEDIA_FAILURE,
  DELETE_SELF_INTRO_MEDIA,
  DELETE_SELF_INTRO_MEDIA_SUCCESS,
  DELETE_SELF_INTRO_MEDIA_FAILURE,
  UPDATE_SELF_INTRO_MEDIA,
  UPDATE_SELF_INTRO_MEDIA_SUCCESS,
  UPDATE_SELF_INTRO_MEDIA_FAILURE,
  // Work Experience Projects
  CREATE_PROJECT_MEDIA,
  CREATE_PROJECT_MEDIA_SUCCESS,
  CREATE_PROJECT_MEDIA_FAILURE,
  FETCH_PROJECT_MEDIA,
  FETCH_PROJECT_MEDIA_SUCCESS,
  FETCH_PROJECT_MEDIA_FAILURE,
  FETCH_PROJECT_MEDIA_LIST,
  FETCH_PROJECT_MEDIA_LIST_SUCCESS,
  FETCH_PROJECT_MEDIA_LIST_FAILURE,
  DELETE_PROJECT_MEDIA,
  DELETE_PROJECT_MEDIA_SUCCESS,
  DELETE_PROJECT_MEDIA_FAILURE,
  UPDATE_PROJECT_MEDIA,
  UPDATE_PROJECT_MEDIA_SUCCESS,
  UPDATE_PROJECT_MEDIA_FAILURE,
  // Eduction Details
  FETCH_CANDIDATE_EDUCATION,
  FETCH_CANDIDATE_EDUCATION_SUCCESS,
  FETCH_CANDIDATE_EDUCATION_FAILURE,
  DELETE_CANDIDATE_EDUCATION,
  DELETE_CANDIDATE_EDUCATION_SUCCESS,
  DELETE_CANDIDATE_EDUCATION_FAILURE,
  // Work Experience Details
  FETCH_CANDIDATE_WORK_EXPERIENCE,
  FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE,
  DELETE_CANDIDATE_WORK_EXPERIENCE,
  DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE,
  // Certifications
  FETCH_CANDIDATE_CERTIFICATIONS,
  FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS,
  FETCH_CANDIDATE_CERTIFICATIONS_FAILURE,
  DELETE_CANDIDATE_CERTIFICATIONS,
  DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS,
  DELETE_CANDIDATE_CERTIFICATIONS_FAILURE,
} from "./actionType";

// Candidate Self Intro Media
export const createSelfIntroMedia = (selfIntroMediaData) => ({
  type: CREATE_SELF_INTRO_MEDIA,
  payload: selfIntroMediaData,
});

export const createSelfIntroMediaSuccess = (selfIntroMedia) => ({
  type: CREATE_SELF_INTRO_MEDIA_SUCCESS,
  payload: selfIntroMedia,
});

export const createSelfIntroMediaFailure = (error) => ({
  type: CREATE_SELF_INTRO_MEDIA_FAILURE,
  payload: error,
});

export const fetchSelfIntroMedia = (id) => ({
  type: FETCH_SELF_INTRO_MEDIA,
  payload: id,
});

export const fetchSelfIntroMediaSuccess = (selfIntroMedia) => ({
  type: FETCH_SELF_INTRO_MEDIA_SUCCESS,
  payload: selfIntroMedia,
});

export const fetchSelfIntroMediaFailure = (error) => ({
  type: FETCH_SELF_INTRO_MEDIA_FAILURE,
  payload: error,
});

export const deleteSelfIntroMedia = (id) => ({
  type: DELETE_SELF_INTRO_MEDIA,
  payload: id,
});

export const deleteSelfIntroMediaSuccess = (selfIntroMedia) => ({
  type: DELETE_SELF_INTRO_MEDIA_SUCCESS,
  payload: selfIntroMedia,
});

export const deleteSelfIntroMediaFailure = (error) => ({
  type: DELETE_SELF_INTRO_MEDIA_FAILURE,
  payload: error,
});

export const updateSelfIntroMedia = (selfIntroMediaData) => ({
  type: UPDATE_SELF_INTRO_MEDIA,
  payload: selfIntroMediaData,
});

export const updateSelfIntroMediaSuccess = (selfIntroMedia) => ({
  type: UPDATE_SELF_INTRO_MEDIA_SUCCESS,
  payload: selfIntroMedia,
});

export const updateSelfIntroMediaFailure = (error) => ({
  type: UPDATE_SELF_INTRO_MEDIA_FAILURE,
  payload: error,
});

// Candidate Work Experience Project Media
export const createProjectMedia = (projectMediaData) => ({
  type: CREATE_PROJECT_MEDIA,
  payload: projectMediaData,
});

export const createProjectMediaSuccess = (projectMedia) => ({
  type: CREATE_PROJECT_MEDIA_SUCCESS,
  payload: projectMedia,
});

export const createProjectMediaFailure = (error) => ({
  type: CREATE_PROJECT_MEDIA_FAILURE,
  payload: error,
});

export const fetchProjectMedia = (id) => ({
  type: FETCH_PROJECT_MEDIA,
  payload: id,
});

export const fetchProjectMediaSuccess = (projectMedia) => ({
  type: FETCH_PROJECT_MEDIA_SUCCESS,
  payload: projectMedia,
});

export const fetchProjectMediaFailure = (error) => ({
  type: FETCH_PROJECT_MEDIA_FAILURE,
  payload: error,
});

export const fetchProjectMediaList = (id) => ({
  type: FETCH_PROJECT_MEDIA_LIST,
  payload: id,
});

export const fetchProjectMediaListSuccess = (projectMediaList) => ({
  type: FETCH_PROJECT_MEDIA_LIST_SUCCESS,
  payload: projectMediaList,
});

export const fetchProjectMediaListFailure = (error) => ({
  type: FETCH_PROJECT_MEDIA_LIST_FAILURE,
  payload: error,
});

export const deleteProjectMedia = (id) => ({
  type: DELETE_PROJECT_MEDIA,
  payload: id,
});

export const deleteProjectMediaSuccess = (projectMedia) => ({
  type: DELETE_PROJECT_MEDIA_SUCCESS,
  payload: projectMedia,
});

export const deleteProjectMediaFailure = (error) => ({
  type: DELETE_PROJECT_MEDIA_FAILURE,
  payload: error,
});

export const updateProjectMedia = (projectMediaData) => ({
  type: UPDATE_PROJECT_MEDIA,
  payload: projectMediaData,
});

export const updateProjectMediaSuccess = (projectMedia) => ({
  type: UPDATE_PROJECT_MEDIA_SUCCESS,
  payload: projectMedia,
});

export const updateProjectMediaFailure = (error) => ({
  type: UPDATE_PROJECT_MEDIA_FAILURE,
  payload: error,
});

// Candidate Education Details
export const fetchCandidateEducation = (id) => ({
  type: FETCH_CANDIDATE_EDUCATION,
  payload: id,
});

export const fetchCandidateEducationSuccess = (educationDetails) => ({
  type: FETCH_CANDIDATE_EDUCATION_SUCCESS,
  payload: educationDetails,
});

export const fetchCandidateEducationFailure = (error) => ({
  type: FETCH_CANDIDATE_EDUCATION_FAILURE,
  payload: error,
});

export const deleteCandidateEducation = (request) => ({
  type: DELETE_CANDIDATE_EDUCATION,
  payload: request,
});

export const deleteCandidateEducationSuccess = (educationDetails) => ({
  type: DELETE_CANDIDATE_EDUCATION_SUCCESS,
  payload: educationDetails,
});

export const deleteCandidateEducationFailure = (error) => ({
  type: DELETE_CANDIDATE_EDUCATION_FAILURE,
  payload: error,
});

// Candidate Work Experience Details
export const fetchCandidateWorkExperience = (id) => ({
  type: FETCH_CANDIDATE_WORK_EXPERIENCE,
  payload: id,
});

export const fetchCandidateWorkExperienceSuccess = (workExperience) => ({
  type: FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  payload: workExperience,
});

export const fetchCandidateWorkExperienceFailure = (error) => ({
  type: FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE,
  payload: error,
});

export const deleteCandidateWorkExperience = (id) => ({
  type: DELETE_CANDIDATE_WORK_EXPERIENCE,
  payload: id,
});

export const deleteCandidateWorkExperienceSuccess = (workExperience) => ({
  type: DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS,
  payload: workExperience,
});

export const deleteCandidateWorkExperienceFailure = (error) => ({
  type: DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE,
  payload: error,
});

// Candidate Certifications
export const fetchCandidateCertifications = (id) => ({
  type: FETCH_CANDIDATE_CERTIFICATIONS,
  payload: id,
});

export const fetchCandidateCertificationsSuccess = (certifications) => ({
  type: FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS,
  payload: certifications,
});

export const fetchCandidateCertificationsFailure = (error) => ({
  type: FETCH_CANDIDATE_CERTIFICATIONS_FAILURE,
  payload: error,
});

export const deleteCandidateCertifications = (request) => ({
  type: DELETE_CANDIDATE_CERTIFICATIONS,
  payload: request,
});

export const deleteCandidateCertificationsSuccess = (certifications) => ({
  type: DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS,
  payload: certifications,
});

export const deleteCandidateCertificationsFailure = (error) => ({
  type: DELETE_CANDIDATE_CERTIFICATIONS_FAILURE,
  payload: error,
});
